(function() {
    'use strict';

    angular.module('formTracking')
        .factory('formTrackingService', function() {
            var data = {
                'siteArea': 'mobility',
                'platformType': 'responsive',
                'loginStatus': 'not logged in',
                'siteStructure': [],
                'pageType': '',
                'oForm': {}
            };

            return {
                track: function(siteStructure, formData) {
                    data.pageType = formData.formStepName;
                    data.siteStructure = siteStructure;
                    data.oForm = formData;

                    //track pageview
                    _ddq.push(['pageview', data]);
                }
            };
        })

    .factory('formErrorTracking', function() {
        var data = {
            'msg': '',
            'field': ''
        };

        return {
            track: function(msg, field) {
                data.msg = msg;
                data.field = field;

                _ddq.push(['validation error', data]);
            }
        };
    });
}());
